export default __webpack_public_path__ + "static/media/avatar.f5a94e4e.png";